import { config } from "../utils/config";
export default class Free {

    id: string;
    type: string;
    quantity: number;
    mainItemId: string;
    name: string;
    productKey: string;
    constructor(freeItem: any = {}) {
        this.id =  freeItem.id ?? '';
        this.type = freeItem.custom?.fields?.lineItemType.toLowerCase() ?? '';
        this.quantity =  freeItem?.quantity ?? 0;
        this.mainItemId = freeItem?.custom?.fields?.lineItemReference ?? '';
        const nameValue = freeItem?.name?.[config('locale')];
        this.name = typeof nameValue === 'string' ? nameValue.trim() : '';
        this.productKey = freeItem.custom?.fields?.productKey;
    }
}